import React, { useState, useEffect } from 'react';
import CarouselButton from './carouselButton/carouselButton';
import './index.scss';

const Carousel = (props) => {
    const {
        arrows = true,
        items: initialItems = [],
        shape,
        showMarkers = true
    } = props;

    const [items, setItems] = useState(initialItems);
    const [visibleItemCount, setVisibleItemCount] = useState(5);
    const [displayIndex, setDisplayIndex] = useState(0);

    const itemWidth = 100 / visibleItemCount;

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 775) {
                setVisibleItemCount(1);
            } else if (width < 1150) {
                setVisibleItemCount(2);
            } else if (width < 1450) {
                setVisibleItemCount(3);
            } else if (width < 1850) {
                setVisibleItemCount(4);
            } else {
                setVisibleItemCount(5);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNext = () => {
        if (initialItems.length === 0) return;

        const newItems = [...items];
        const firstItem = newItems.shift();
        newItems.push(firstItem);

        setItems(newItems);
        setDisplayIndex((prev) => (prev + 1) % initialItems.length);
    };

    const handlePrev = () => {
        if (initialItems.length === 0) return;

        const newItems = [...items];
        const lastItem = newItems.pop();
        newItems.unshift(lastItem);

        setItems(newItems);
        setDisplayIndex((prev) => (prev - 1 + initialItems.length) % initialItems.length);
    };

    const onMarkerClick = (targetIndex) => {
        if (targetIndex === displayIndex || initialItems.length === 0) return;

        const diff = (targetIndex - displayIndex + initialItems.length) % initialItems.length;

        const newItems = [...items];
        const shifted = newItems.splice(0, diff);
        newItems.push(...shifted);

        setItems(newItems);
        setDisplayIndex(targetIndex);
    };

    return (
        <div className='slideshow'>
            <div className='carousel_container'>
                {arrows && (
                    <div className='carousel_arrow_wrapper left'>
                        <CarouselButton onSlide={handlePrev} direction='left' />
                    </div>
                )}
                <div className={`carousel_view_window ${(visibleItemCount !== 1 && visibleItemCount % 2 !== 0) ? 'fade' : ''}`}>
                    <div
                        className='carousel_track'
                        style={{
                            display: 'flex',
                            transition: 'none',
                            transform: 'translateX(0)'
                        }}
                    >
                        {items.slice(0, visibleItemCount).map((item, index) => (
                            <div
                                key={`${item.key || index}-${index}`}
                                className='carousel_slide_container'
                                style={{
                                    flex: `0 0 ${itemWidth}%`
                                }}
                            >
                                <div
                                    className='carousel_slide'
                                    style={{
                                        borderRadius: shape === 'circle' ? '50%' : '15px'
                                    }}
                                >
                                    {item}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {arrows && (
                    <div className='carousel_arrow_wrapper right'>
                        <CarouselButton onSlide={handleNext} direction='right' />
                    </div>
                )}
            </div>
            {showMarkers && (
                <div className='carousel_indices_container'>
                    {initialItems.map((_, index) => (
                        <div
                            key={index}
                            onClick={() => onMarkerClick(index)}
                            className={`carousel_indices ${displayIndex === index ? 'carousel_indices_active' : ''}`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default Carousel;